import { Grid } from "@mui/material";
import { FormikProps } from "formik";

import { FormikAutocomplete } from "@/common/components/fields/formik/formik-autocomplete/FormikAutocomplete";
import { FormikDatePicker } from "@/common/components/fields/formik/formik-date-picker/FormikDatePicker";
import { DropdownOptions } from "@/common/hooks/useDropdownOptions";
import { EditClientType } from "@/pages/clients/client/components/tabs/master-data-tab/views/personal-data/EditClient.types";
import { useTranslation } from "@/translations";

interface Props {
  formik: FormikProps<EditClientType>;
  dropdownOptions: DropdownOptions;
}

export function PersonalDataBackgroundSection({ formik, dropdownOptions }: Props) {
  const { t } = useTranslation();

  return (
    <Grid container rowSpacing={2} columnSpacing={2}>
      <Grid size={6}>
        <FormikDatePicker
          formik={formik}
          fieldName="initialRegistrationDate"
          label={t("clients.create.creationDate")}
          required
        />
      </Grid>
      <Grid size={6}>
        <FormikAutocomplete
          formik={formik}
          fieldName="contactSource"
          label={t("clients.create.contactSource")}
          options={dropdownOptions.contactSources}
        />
      </Grid>
      <Grid size={6}>
        <FormikAutocomplete
          formik={formik}
          fieldName="qualification"
          label={t("clients.client.masterData.personalData.qualification")}
          options={dropdownOptions.qualifications}
        />
      </Grid>
      <Grid size={6}>
        <FormikAutocomplete
          formik={formik}
          fieldName="mediaInquiry"
          label={t("clients.client.masterData.personalData.mediaInquiry")}
          options={dropdownOptions.mediaInquiries}
        />
      </Grid>
      <Grid size={6}>
        <FormikAutocomplete
          formik={formik}
          fieldName="placeOfBirth"
          label={t("clients.client.masterData.personalData.placeOfBirth")}
          options={dropdownOptions.countries}
          freeSolo
        />
      </Grid>
      <Grid size={6}>
        <FormikAutocomplete
          formik={formik}
          fieldName="nationality"
          label={t("clients.client.masterData.personalData.nationality")}
          options={dropdownOptions.citizenships}
        />
      </Grid>
      <Grid size={6}>
        <FormikAutocomplete
          formik={formik}
          fieldName="maritalStatus"
          label={t("clients.client.masterData.personalData.maritalStatus")}
          options={dropdownOptions.maritalStatuses}
        />
      </Grid>
      <Grid size={6}>
        <FormikAutocomplete
          formik={formik}
          fieldName="livingSituation"
          label={t("clients.client.masterData.personalData.livingSituation")}
          options={dropdownOptions.livingSituations}
        />
      </Grid>
    </Grid>
  );
}
